<div class="wrap-items">
  <div *ngIf="printData.length === 0">
    No data to show, Please press button Reload to get data.
    <br>
    <button class="btn btn-success" (click)="initData()">Reload</button>
    <p class="text-center" *ngIf="isLoading">
      <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
      <span class="sr-only">Loading...</span>
    </p>
  </div>
  <div *ngIf="printData.length !== 0">
    <div class="layout-print1 page-size" *ngFor="let item of printData">
      <div class="item" style="display: inline-block">
        <div class="item item-sm" [class.selected]="item.selected" (click)="initData('item-sm'); item.selected = !item.selected">
          <div class="qrcode-img">
            <ngx-qrcode [qrc-element-type]="'img'" qrc-class="qrcode-sm-{{this.configCss['qrcode-sm'].value[0]*10}}" [qrc-value]="item.serialId + '-' + item.noId + '-' + item.hmac"></ngx-qrcode>
          </div>
          <div class="info info-sm">
            <span class="product-id"> {{item.productId}} </span>
            <br>
            <span class="description"> {{ item.description }} </span>
            <br>
            <b>SN</b>: {{item.serialId}}
            <br>
            <b>NO</b>: {{item.noId}}
          </div>
        </div>
        <div class="item item-sm" [class.selected]="item.selected" (click)="initData('item-sm'); item.selected = !item.selected">
          <div class="qrcode-img">
            <ngx-qrcode [qrc-element-type]="'img'" qrc-class="qrcode-sm-{{this.configCss['qrcode-sm'].value[0]*10}}" [qrc-value]="item.serialId + '-' + item.noId + '-' + item.hmac"></ngx-qrcode>
          </div>
          <div class="info info-sm">
            <span class="product-id"> {{item.productId}} </span>
            <br>
            <span class="description"> {{ item.description }} </span>
            <br>
            <b>SN</b>: {{item.serialId}}
            <br>
            <b>NO</b>: {{item.noId}}
          </div>
        </div>
        <div class="item item-sm" [class.selected]="item.selected" (click)="initData('item-sm'); item.selected = !item.selected">
            <div class="qrcode-img">
              <ngx-qrcode [qrc-element-type]="'img'" qrc-class="qrcode-sm-{{this.configCss['qrcode-sm'].value[0]*10}}" [qrc-value]="item.serialId + '-' + item.noId + '-' + item.hmac"></ngx-qrcode>
            </div>
            <div class="info info-sm">
              <span class="product-id"> {{item.productId}} </span>
              <br>
              <span class="description"> {{ item.description }} </span>
              <br>
              <b>SN</b>: {{item.serialId}}
              <br>
              <b>NO</b>: {{item.noId}}
            </div>
          </div>
          <div class="item item-sm" [class.selected]="item.selected" (click)="initData('item-sm'); item.selected = !item.selected">
            <div class="qrcode-img">
              <ngx-qrcode [qrc-element-type]="'img'" qrc-class="qrcode-sm-{{this.configCss['qrcode-sm'].value[0]*10}}" [qrc-value]="item.serialId + '-' + item.noId + '-' + item.hmac"></ngx-qrcode>
            </div>
            <div class="info info-sm">
              <span class="product-id"> {{item.productId}} </span>
              <br>
              <span class="description"> {{ item.description }} </span>
              <br>
              <b>SN</b>: {{item.serialId}}
              <br>
              <b>NO</b>: {{item.noId}}
            </div>
          </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="printData.length !== 0" class="print-btn noprint">
  <button (click)="print()" class="button" href="#">Print</button>
</div>
<div [innerHTML]="style"></div>


// WEBPACK FOOTER //
// /build/client-cms/src/app/print-qrcode-small/print-qrcode-small.component.html